import { render, staticRenderFns } from "./SvgSearch.vue?vue&type=template&id=8e46f60a&"
import script from "./SvgSearch.vue?vue&type=script&lang=js&"
export * from "./SvgSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports